/** Share-package animated raster paths (DEC-083). */

export function isAnimatedSharePath(path: string): boolean {
  return /\.(gif|webp)(?:$|\?)/i.test(path);
}

/**
 * Lightbox / fullscreen URL: full animated file only when animateImages is on.
 * Otherwise prefer the ingest JPEG thumb so `<img>` cannot loop.
 */
export function resolveShareLightboxUrl(options: {
  fullUrl: string;
  thumbUrl: string;
  animateImages?: boolean;
}): string {
  const { fullUrl, thumbUrl, animateImages } = options;
  if (animateImages === true || !isAnimatedSharePath(fullUrl)) {
    return fullUrl;
  }
  return thumbUrl || fullUrl;
}
